import { Container, Row } from 'react-bootstrap';
import { CEOStatsCard } from './ceoDashboardModules/CEOStatsCard';
import { PaymentInvoices } from './ceoDashboardModules/paymentAndInvoices/PaymentInvoices';
import { CEOSalesAndConversion } from './ceoDashboardModules/ceoSalesAndConversionModule/CEOSalesAndConversion';
import { CEOFunnelAndClients } from './ceoDashboardModules/ceoFunnelAndClients/CEOFunnelAndClients';

export const CEODashboard = () => {

    return (
        <Container fluid className='px-0 py-4' >
            <CEOStatsCard />

            <Row className="g-3 mb-4 ">
                <CEOFunnelAndClients />
            </Row>

            <Row className="g-3 mb-4">
                <CEOSalesAndConversion />
            </Row>

            <Row className="g-3">
                <PaymentInvoices />
            </Row>
        </Container >
    );
};